export default "__VITE_PUBLIC_ASSET__21ec61a6__"